import { optionTitle_DistributionGroups } from './DistributionGroupsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
/**
 * Distribution Groups options settings
 */
let DistributionGroupsOption: LazyOption = createLazyOption(
    {
        key: 'generaldistributionGroups',
        titleStringKey: optionTitle_DistributionGroups,
        searchTermsStringKey: optionTitle_DistributionGroups,
        hideTitleInFullOptions: true,
        isHidden: () => isConsumer() || !isFeatureEnabled('tri-distributionGroupsOption'),
        allowedOptionKeys: ['DistributionGroups'],
    },
    lazyFullModule,
    m => m.default
);
export default DistributionGroupsOption;
